<template lang="pug">
section
  s-page-title(title='Запись на осмотр')
  v-card
    s-data-filter(@search='debouncedSearch' :initial='dataFilter.search')
      template(slot='controls')
        v-layout(wrap)
          v-flex(xs12 sm6)
            s-schedule-complex-picker(
              :return-object='true'
              @change='setComplexId'
              v-model='complex'
              label='Выберите комплекс'
            )
          v-flex(xs12 sm6 class='text-xs-right')
            v-btn(@click='getFileXls()' small flat)
              v-icon(left small) save_alt
              | Загрузить файл
    v-toolbar(flat color='white')

    v-divider
    v-data-table(
      :loading='isLoading'
      :headers='headers'
      :items='list'
      :total-items='total'
      :pagination='dataFilter'
      :rows-per-page-items='$config.rowsPerPageItems'
      class='mobile-look-table'
      @update:pagination='updatePagination'
    )
      template(slot='items' slot-scope='props')
        tr(:class='{"current": props.item.is_now===1,"with-pointer": true,"canceled": props.item.status==="canceled", "done": props.item.status==="done"}')
          td(data-label='#ID') {{ props.item.id }}
          td(data-label='Дата') {{ props.item.on_day | date }}
          td(data-label='Время' class='assign-double start-time') <div class="bolder">{{ props.item.start | time }} </div>{{ props.item.end | time }}
          td(data-label='Клиент' class='assign-double') <div class="bolder">{{ props.item.phone | phone}}</div>{{ props.item.name }}
          td(data-label='Объект' class="assign-object") <div class="bolder">{{ props.item.complex_full_name }}</div>{{ props.item.object_name }}, {{ props.item.rooms_type }} № {{ props.item.room }}
          td(data-label='Договор') <div class="bolder">{{ props.item.deal_type}}</div>{{ props.item.deal_num }}
          td(data-label='Действия' class='text-xs-right wrapless crud-tools')
            v-btn(icon @click.stop='onCancel(props.item)')
              v-icon(small) highlight_off
            v-btn(icon @click.stop='onConfirm(props.item)')
              v-icon(small) check_circle_outline
</template>

<script>
import { debounce } from 'lodash'
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'
import http from '@/http'

export default {
  data: () => ({
    complex: {},
    headers: [
      { text: '#ID', align: 'left', width: '1%', sortable: false },
      {
        text: 'Дата',
        align: 'left',
        value: 'start',
        width: '3%',
        defaul: true
      },
      {
        text: 'Время',
        align: 'left',
        width: '3%',
        sortable: false
      },
      {
        text: 'ФИО',
        align: 'left',
        value: 'name',
        width: '25%'
      },
      {
        text: 'Объект',
        align: 'left',
        value: 'complex_full_name',
        width: '25%'
      },
      {
        text: 'Договор',
        align: 'left',
        value: 'room',
        width: '25%'
      },
      {
        text: 'Действия',
        align: 'left',
        width: '25%',
        sortable: false
      }
    ]
  }),

  methods: {
    async onCancel(item) {
      let question =
        item.status == 'canceled'
          ? 'Сбросить статус записи?'
          : 'Подтверждаете, что клиент не пришел?'
      if (await this.$confirm(question)) {
        await this.cancel({ item })
        this.fetch()
      }
    },

    async onConfirm(item) {
      let question =
        item.status == 'done' ? 'Сбросить статус записи?' : 'Клиент пришел?'
      if (await this.$confirm(question)) {
        await this.confirm({ item })
        this.fetch()
      }
    },
    getFileXls() {
      http({
        method: 'get',
        url: `${this.$config.baseURL}/manager/scheduleassign/filelist${
          this.complex.id > 0 ? '?complex_id=' + this.complex.id : ''
        }`,
        responseType: 'blob'
      })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute(
            'download',
            `${
              this.complex.id > 0 ? this.complex.complex_code + '_' : ''
            }visits_list.xlsx`
          ) //or any other extension
          document.body.appendChild(link)
          link.click()
          link.remove()
        })
        .catch(() => {})
    },
    setComplexId(complex = null) {
      if (complex) this.setDataFilter({ complex_id: complex.id })
      else this.setDataFilter({ complex_id: null })
      this.fetch()
    },
    fetch() {
      this.fetchList({ config: { params: this.dataFilter } })
    },

    updatePagination(pagination) {
      this.setDataFilter(pagination)
      this.fetch()
    },

    debouncedSearch: debounce(function(search) {
      this.setDataFilter({ search, page: 1 })
      this.fetch()
    }, 250),

    ...mapActions('objectmanager/schedule', ['fetchList', 'confirm', 'cancel']),
    ...mapMutations('objectmanager/schedule', ['setDataFilter'])
  },

  computed: {
    ...mapState('objectmanager/schedule', ['total', 'dataFilter']),
    ...mapGetters('objectmanager/schedule', ['list', 'isLoading'])
  }
}
</script>

<style scoped>
.bolder {
  font-weight: 500;
  font-size: 15px;
}
.mobile-look-table >>> .current td.start-time {
  background-color: #4caf5038;
}

tr.canceled {
  background-color: #ff52521f;
}

tr.done {
  background-color: #4caf5030;
}
</style>
